/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { PartnerService } from '../../services/partner.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { EMessageType } from 'src/app/shared/data/response-default.interface';

@Component({
  selector: 'app-add-new-partner',
  templateUrl: './add-new-partner.component.html',
  styleUrls: ['./add-new-partner.component.scss']
})
export class AddNewPartnerComponent {
  ERoleAdminString = ERoleAdminString;
  @Output() recarregarListagem = new EventEmitter();
  formAberto = false;

  formPartner = new UntypedFormGroup({
    name: new UntypedFormControl('', [Validators.required]),
    trading: new UntypedFormControl(''),
    document: new UntypedFormControl('', [Validators.required]),
    type: new UntypedFormControl(null, [Validators.required]),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    phone: new UntypedFormControl('', [Validators.required]),
    logo: new UntypedFormControl('')
  });

  opcoesTipoPartner: string[] = [];

  imageFile?: { link: string; file: any; name: string; base64: string };
  imagemCarregada = false;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly partnerService: PartnerService,
    private readonly toastService: ToastService
  ) {
    this.opcoesTipoPartner = this.partnerService.opcoesTipoParceiro;
  }

  public salvarPartner(): void {
    if (this.formPartner.invalid) {
      this.toastService.toast("Preencha todos os campos obrigatórios antes de salvar.", EMessageType.Error);
      this.formPartner.markAllAsTouched();
      return;
    }

    if (this.formPartner.valid) {
      this.partnerService.adicionarParceiro(this.formPartner.getRawValue()).subscribe((resposta) => {
        if (resposta.messages && resposta.messages.length > 0) {
          this.toastService.toast(resposta.messages);
        }

        if (resposta.isSucceed) {

          this.salvarImagem(resposta.data);
          this.formAberto = false;
          this.formPartner.reset();
          this.imageFile = undefined;
          this.imagemCarregada = false;
          this.recarregarListagem.emit();

        }
      });
    }
  }

  public salvarImagem(partnerId: string): void {
    if (!this.imageFile) return;

    const imagemFormData = new FormData();

    imagemFormData.append('id', partnerId);
    imagemFormData.append('image', this.imageFile.file);

    this.partnerService.adicionarImagemParceiro(imagemFormData).subscribe((resposta) => {
      if (resposta.messages && resposta.messages.length > 0) {
        this.toastService.toast(resposta.messages);
      }
    });
  }

  public onImageInput(evento: Event): void {
    const { files } = evento.target as HTMLInputElement;

    if (files && files.length > 0) {
      const reader = new FileReader();

      reader.readAsDataURL(files[0]);

      reader.onload = (_event: any) => {
        this.imageFile = {
          link: _event.target.result,
          file: files[0],
          name: files[0].name,
          base64: reader.result!.toString().split(',')[1]
        };

        this.formPartner.get('logo')!.patchValue(this.imageFile.base64);

        this.imagemCarregada = true;
        this.cdr.markForCheck();
      };
    }
  }
}